import { usePocket } from "../contexts/PocketContext";

export const NotRegister = ({ children }) => {
    const { logout } = usePocket();

    function NotFoundLocation() {      
        return (
            <section className="bg-white dark:bg-gray-900 ">
                <div className="container min-h-screen px-6 py-12 mx-auto lg:flex lg:items-center lg:gap-12">
                    <div className="wf-ull lg:w-1/2">
                        <p className="text-sm font-medium text-blue-500 dark:text-blue-400">403 Hatası</p>
                        <h1 className="mt-3 text-2xl font-semibold text-gray-800 dark:text-white md:text-3xl">Derslere kayıtlı değilsiniz.</h1>
                        <p className="mt-4 text-gray-500 dark:text-gray-400">Giriş yaptığınız mail adresi RUZEM'e kayıtlı değil ya da RUZEM'de yer alan e-posta adresi ile uyuşmuyor. Eğer bir hata olduğunu düşünüyorsanız WhatsApp ya da e-posta ile irtibata geçebilirsiniz.</p>

                        <div className="flex items-center mt-6 gap-x-3">
                            <button className="flex items-center justify-center w-1/2 px-5 py-2 text-sm text-gray-700 transition-colors duration-200 bg-white border rounded-lg gap-x-2 sm:w-auto dark:hover:bg-gray-800 dark:bg-gray-900 hover:bg-gray-100 dark:text-gray-200 dark:border-gray-700">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-5 h-5 rtl:rotate-180">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18" />
                                </svg>


                                <span><a href="/">Anasayfaya Dön</a></span>
                                
                            </button>
                            <button onClick={logout}className="flex items-center justify-center w-1/2 px-5 py-2 text-sm text-gray-700 transition-colors duration-200 bg-white border rounded-lg gap-x-2 sm:w-auto dark:hover:bg-gray-800 dark:bg-gray-900 hover:bg-gray-100 dark:text-gray-200 dark:border-gray-700">
                                <span><a href="/">Çıkış Yap</a></span>   
                            </button>
                        </div>
                    </div>
                    <div className="relative w-full mt-8 lg:w-full lg:mt-0">
                        <img className=" w-full lg:h-[32rem] h-80 md:h-96 rounded-lg object-cover " src="https://trthaberstatic.cdn.wp.trt.com.tr/resimler/1828000/buyuk-camlica-camii-a-1828580.jpg" alt="" />
                    </div>
                </div>
            </section>
        );
      }
    return (
    <>
        {NotFoundLocation()}
    </>
    )};